import React, { useEffect, useMemo, useState } from "react";
import { Avatar, Box, Chip, Grid, Typography, Button, Tabs, Tab, IconButton, Popper, Grow, Paper, TextField, Stack, Collapse, Menu, MenuItem, Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions, keyframes, Popover, FormControlLabel, Checkbox } from "@mui/material";
import TableComponent from "components/grid";
import { ReactComponent as EditIcon } from "assets/icons/EditIcon.svg";
import { MdDeleteOutline } from "react-icons/md";
import StatusBadge from "components/badge/StatusBadge";
import { FaPlus } from "react-icons/fa6";
import CustomButton from "components/Button";
import AddActionTracker from "./addTracker";
import ClickAwayListener from '@mui/material/ClickAwayListener';
import Select from "react-select";
import { useDeleteActionTrackerMutation, useGetActionTrackerStatusCountQuery, useGetActionTrackerStatusCountByTypeQuery, useLazyGetAllActionTrackerQuery, useLazyGetExportAllActionTrackerQuery, useLazyGetActionTrackerStatusCountQuery, useLazyGetActionTrackerStatusCountByTypeQuery } from "store/slices/apis/actionTrackerSlice";
import { useGetAllProjectsQuery } from "store/slices/apis/projectApiSlice";
import { useParams } from "react-router-dom";
import moment from "moment";
import EditActionTracker from "./editTracker";
import { LuEye, LuRefreshCw, LuSearch } from "react-icons/lu";
import ViewActionTracker from "./ViewActionTracker";
import { DEFAULT_DATE_FORMAT } from "config";
import { MdOutlineFilterAlt, MdOutlineFileDownload } from "react-icons/md";
import CustomPagination from "components/CustomPagination";
import { useGetAllContactsQuery } from "store/slices/apis/contactSlice";
import ActionCategoryChart from "./ActionCategoryChart";
import ActionPriorityWiseChart from "./ActionPriorityWiseChart";
import ThisWeekCloserChart from "./ThisWeekCloserChart";
import AgeingAnalysisChart from "./AgeingAnalysisChart";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import { RxCross2 } from "react-icons/rx";
import { closeSnackbar, openSnackbar } from "store/slices/snackbar";
import { useDispatch } from "store";
import MoreHorizIcon from "@mui/icons-material/MoreHoriz";
import { exportToExcel } from "utils/ExportToExcel";
import { skipToken } from "@reduxjs/toolkit/query";
import { usePermission } from "hooks/usePermission";
import { ACTION_TRACKER_CREATE, ACTION_TRACKER_DELETE, ACTION_TRACKER_EDIT, ACTION_TRACKER_VIEW } from "helpers/permissionConfig";
import { useGetPortfolioSummaryQuery } from "store/slices/apis/portfolioSummarySlice";
import { useGetMasterDataQuery } from "store/slices/apis/masterConfigation";
import { mapAndSortAlphabetically } from "utils/mapSortHelper";
import PendingApproval from "./pendingApproval";
import ProjectLastUpdatedOn from "components/ProjectLastUpdatedOn";
import { useGetLastUpdatedOnStatusQuery } from "store/slices/apis/projectStatusApiSlice";
import EnterprisePageShell from "components/EnterprisePageShell";
import { enterpriseTokens } from "styles/theme";



const DueDateCell = ({ row }) => {
    const [anchorEl, setAnchorEl] = useState(null);

    const allDates = row?.revisedDueDate
        ? [row?.dueDate, ...row?.revisedDueDateHistory]
        : [row?.dueDate];

    // 1. Clean the data immediately: Filter nulls, format to strings, and remove duplicates
    const uniqueDates = useMemo(() => {
        const rawDates = row?.revisedDueDate
            ? [row?.dueDate, ...row?.revisedDueDateHistory]
            : [row?.dueDate];

        const formatted = rawDates
            .filter(Boolean)
            .map(date => moment(date).format(DEFAULT_DATE_FORMAT));

        return [...new Set(formatted)];
    }, [row]);


    const lastTwoDates = uniqueDates.slice(-2);
    const extraCount = uniqueDates.length - lastTwoDates.length;

    console.log(row?.customId, lastTwoDates, extraCount);


    const handleOpen = (event) => setAnchorEl(event.currentTarget);
    const handleClose = () => setAnchorEl(null);


    return (

        extraCount > 0 && (
            <>
                <IconButton size="small" onClick={handleOpen}>
                    <MoreHorizIcon fontSize="small" />
                </IconButton>

                <Popover
                    open={Boolean(anchorEl)}
                    anchorEl={anchorEl}
                    onClose={handleClose}
                    anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
                >
                    <Box sx={{ p: 1, gap: 0.5, flexWrap: "wrap" }}>
                        {[
                            ...new Set(uniqueDates || [])
                        ]
                            .slice(0, -2)
                            .map((date, i) => (
                                <Box key={i} sx={{ width: "100%", m: 1 }}>
                                    <Chip
                                        label={moment(date).format(DEFAULT_DATE_FORMAT)}
                                        sx={{
                                            textDecoration: "line-through",
                                            color: "#e51c1cff",
                                            backgroundColor: "#f5ccccff",
                                            fontWeight: 500,
                                            height: "20px",
                                            borderRadius: "3px",
                                            padding: "2px 6px",
                                            fontFamily: "Outfit",
                                            fontSize: "12px",
                                            marginRight: "5px",
                                        }}
                                    />
                                </Box>
                            ))}

                    </Box>
                </Popover>
            </>
        )
    );
};

const calenderSVG = (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clip-path="url(#clip0_894_610)">
            <path d="M12.6667 1.33333H12V0.666667C12 0.489856 11.9298 0.320286 11.8047 0.195262C11.6797 0.0702379 11.5101 0 11.3333 0C11.1565 0 10.987 0.0702379 10.8619 0.195262C10.7369 0.320286 10.6667 0.489856 10.6667 0.666667V1.33333H5.33333V0.666667C5.33333 0.489856 5.2631 0.320286 5.13807 0.195262C5.01305 0.0702379 4.84348 0 4.66667 0C4.48986 0 4.32029 0.0702379 4.19526 0.195262C4.07024 0.320286 4 0.489856 4 0.666667V1.33333H3.33333C2.4496 1.33439 1.60237 1.68592 0.97748 2.31081C0.352588 2.93571 0.00105857 3.78294 0 4.66667L0 12.6667C0.00105857 13.5504 0.352588 14.3976 0.97748 15.0225C1.60237 15.6474 2.4496 15.9989 3.33333 16H12.6667C13.5504 15.9989 14.3976 15.6474 15.0225 15.0225C15.6474 14.3976 15.9989 13.5504 16 12.6667V4.66667C15.9989 3.78294 15.6474 2.93571 15.0225 2.31081C14.3976 1.68592 13.5504 1.33439 12.6667 1.33333ZM1.33333 4.66667C1.33333 4.13623 1.54405 3.62753 1.91912 3.25245C2.29419 2.87738 2.8029 2.66667 3.33333 2.66667H12.6667C13.1971 2.66667 13.7058 2.87738 14.0809 3.25245C14.456 3.62753 14.6667 4.13623 14.6667 4.66667V5.33333H1.33333V4.66667ZM12.6667 14.6667H3.33333C2.8029 14.6667 2.29419 14.456 1.91912 14.0809C1.54405 13.7058 1.33333 13.1971 1.33333 12.6667V6.66667H14.6667V12.6667C14.6667 13.1971 14.456 13.7058 14.0809 14.0809C13.7058 14.456 13.1971 14.6667 12.6667 14.6667Z" fill="#433F5E" />
            <path d="M8 11C8.55228 11 9 10.5523 9 10C9 9.44772 8.55228 9 8 9C7.44772 9 7 9.44772 7 10C7 10.5523 7.44772 11 8 11Z" fill="#433F5E" />
            <path d="M4.66656 11C5.21885 11 5.66656 10.5523 5.66656 10C5.66656 9.44772 5.21885 9 4.66656 9C4.11428 9 3.66656 9.44772 3.66656 10C3.66656 10.5523 4.11428 11 4.66656 11Z" fill="#433F5E" />
            <path d="M11.3334 11C11.8857 11 12.3334 10.5523 12.3334 10C12.3334 9.44772 11.8857 9 11.3334 9C10.7811 9 10.3334 9.44772 10.3334 10C10.3334 10.5523 10.7811 11 11.3334 11Z" fill="#433F5E" />
        </g>
        <defs>
            <clipPath id="clip0_894_610">
                <rect width="16" height="16" fill="white" />
            </clipPath>
        </defs>
    </svg>

);
const getDelayAvatar = (data) => {
    const dueDate = data.dueDate ? new Date(data.dueDate) : null;
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    if (dueDate) dueDate.setHours(0, 0, 0, 0);
    if (dueDate && dueDate < today) {
        const diffMs = today - dueDate; // difference in milliseconds
        const diffDays = Math.ceil(diffMs / (1000 * 60 * 60 * 24));
        return diffDays;
    } else {
        return 0;
    }
}
const getStatusColor = (data) => {
    if (!data) return "purple";

    const status = (data.status || "").toLowerCase();
    const dueDate = data.dueDate ? new Date(data.dueDate) : null;
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    if (dueDate) dueDate.setHours(0, 0, 0, 0);


    // Case 1: In Progress & overdue
    if (status === "in progress" && dueDate && dueDate < today) {
        return { bg: "#FFD7D8", text: "#FF383C" };
    }

    // Case 2: In Progress & future due date
    if (status === "in progress" && dueDate && dueDate >= today) {
        return { bg: "orange", text: "white" };
    }

    // Case 3: Completed or Closed
    if (status === "completed" || status === "closed") {
        return { bg: "#E1FFBB", text: "#34A853" };
    }
    // Case 4: In Progress & future due date
    if (status === "delayed" && dueDate && dueDate < today) {
        return { bg: "#FFD7D8", text: "#FF383C" };
    }
    // Case 5: Completed or Closed
    if (status === "delayed" && dueDate && dueDate >= today) {
        return { bg: "#E1FFBB", text: "#34A853" };
    }
    // Default
    return "purple";
};









const ActionTracker = () => {

    const { projectId } = useParams();

    const [selectedProjectId, setSelectedProjectId] = useState("");

    const [menuAnchorEl, setMenuAnchorEl] = useState(null);
    const [menuRow, setMenuRow] = useState(null);
    const [isDeleteModal, setDeleteModal] = useState(false);
    const dispatch = useDispatch();

    const createAccess = usePermission(ACTION_TRACKER_CREATE);
    const editAccess = usePermission(ACTION_TRACKER_EDIT);
    const deleteAccess = usePermission(ACTION_TRACKER_DELETE);
    const viewAccess = usePermission(ACTION_TRACKER_VIEW);

    const [actionDeleteFn, actionDeleteRes] = useDeleteActionTrackerMutation();





    // master data options
    const module = "ActionTracker";

    const effectiveProjectId = projectId || selectedProjectId;


    const { data: actionSubProjectRes } = useGetMasterDataQuery(
        {
            module: module,
            category: 'SubProject',
            ProjectId: effectiveProjectId,
        },
        {
            skip: !effectiveProjectId
        }
    );

    const subProjectData = actionSubProjectRes?.data || [];
    const actionSubProjects = mapAndSortAlphabetically(subProjectData);
    const hasSubProjects = actionSubProjects?.length > 0;

    const { data: actionCategoriesRes } = useGetMasterDataQuery({ module: module, category: 'Category', ProjectId: projectId });

    const categoryData = actionCategoriesRes?.data || [];
    const actionCategories = mapAndSortAlphabetically(categoryData);

    const { data: actionSourceRes } = useGetMasterDataQuery({ module: module, category: 'Source', ProjectId: projectId });

    const actionSourceData = actionSourceRes?.data || [];
    const actionSource = mapAndSortAlphabetically(actionSourceData);

    const { data: actionPriorityRes } = useGetMasterDataQuery({ module: module, category: 'Priority', ProjectId: projectId });

    const actionPriorityData = actionPriorityRes?.data || [];
    const actionPriority = (actionPriorityData || []).map(p => ({
        value: p?.value,
        label: p?.value,
    }));

    const { data: actionStatusRes } = useGetMasterDataQuery({ module: module, category: 'Status', ProjectId: projectId });

    const actionStatusData = actionStatusRes?.data || [];
    const actionStatus = (actionStatusData || []).map(p => ({
        value: p?.value,
        label: p?.value,
    }));

    const { data: actionDecisionVsOperationalRes } = useGetMasterDataQuery({ module: module, category: 'DecisionVsOperational' });

    const actionDecisionVsOperationalData = actionDecisionVsOperationalRes?.data || [];
    const actionDecisionVsOperational = (actionDecisionVsOperationalData || []).map(p => ({
        value: p?.value,
        label: p?.value,
    }));
    // master data options


    const handleMenuOpen = (event, row) => {
        event.stopPropagation(); // prevent row click if any
        setMenuAnchorEl(event.currentTarget);
        setMenuRow(row);
    };

    const handleDeleteActionTracker = () => {
        if (isDeleteModal) {
            handleMenuClose();
        }
        setDeleteModal((prev) => !prev);
    }

    const handleConfirmationDelete = () => {
        actionDeleteFn(menuRow?.projectActionId)
    }

    React.useEffect(() => {
        if (actionDeleteRes?.isSuccess) {
            if (actionDeleteRes?.data?.status?.toLowerCase() == 'success') {
                openNotification(actionDeleteRes?.data?.message, 'success')
                handleDeleteActionTracker();
            } else {
                openNotification(actionDeleteRes?.data?.message, 'error')
            }
        }
    }, [actionDeleteRes?.isSuccess]);


    React.useEffect(() => {
        if (actionDeleteRes?.isError) {
            if (actionDeleteRes?.error?.data?.status?.toLowerCase() == 'error') {
                openNotification(actionDeleteRes?.error?.data?.message, 'error')
            } else {
                openNotification(actionDeleteRes?.error?.data?.message ?? 'Something went wrong!', 'error')
            }
            handleDeleteActionTracker();
        }
    }, [actionDeleteRes?.isError]);

    const handleMenuClose = () => {
        setMenuAnchorEl(null);
        setMenuRow(null);
    };

    const handleMenuView = () => {
        if (menuRow) {
            handleViewClick(menuRow);
        }
        handleMenuClose();
    };

    const handleMenuEdit = () => {
        if (menuRow) {
            handleEditTracker(menuRow);
        }
        handleMenuClose();
    };

    const [open, setOpen] = React.useState(false);

    //const projectType = localStorage.getItem("projectType") || "all";
    const [projectType, setProjectType] = useState(localStorage.getItem("projectType") || "all")

    // sorting asc desc
    const [sortOrder, setSortOrder] = React.useState('desc');
    const [sortBy, setSortBy] = React.useState('dueDate');

    // page size
    const [pageNumber, setPageNumber] = React.useState(1);
    const [pageSize, setPageSize] = React.useState(10);

    // page size
    const [isApplyFilter, setIsApplyFIlter] = React.useState(false);
    const [searchText, setSearchText] = useState("");

    const [loading, setLoading] = useState(false);
    const [tabValue, setTabValue] = useState(0);
    const anchorRef = React.useRef(null);
    const [isAddActionTracker, setIsAddActionTracker] = useState(false);
    const [selectedIndex, setSelectedIndex] = React.useState(1);

    const [isEditTracker, setIsEditTracker] = useState(false);
    const [isViewTracker, setIsViewTracker] = useState(false);
    const [rowData, setRowData] = useState(false);

    const [filters, setFilters] = useState({
        ProjectId: projectId == undefined ? null : projectId,
        SortBy: sortBy,
        SortOrder: sortOrder,
        PageNumber: pageNumber,
        PageSize: pageSize,
        SearchText: "",
        ProjectType: projectType,
        ShowOverdueOnly: false,
        isActive: true
    });
    const [actionContact, setActionContact] = useState([]);
    // const actionTrackerList = useLazyGetAllActionTrackerQuery(
    //     {
    //         ProjectId: projectId,
    //         SortBy: sortBy,
    //         SortOrder: sortOrder,
    //         PageNumber: pageNumber,
    //         PageSize: pageSize,
    //         ...(tabValue > 0 && { Status: actionStatus[tabValue - 1]?.value })
    //     }
    // )
    const [trigger, { data: actionTrackerList, isFetching }] = useLazyGetAllActionTrackerQuery();

    const { data, error, isLoading, isFetching: isProjectFething, refetch } = useGetAllProjectsQuery(projectType);
    const { data: portfolioData, isFetching: portfolioLoader, isError: portfolioError } = useGetPortfolioSummaryQuery();

    const projectData = data?.data || [];
    const filteredProjectData = projectData.filter((data) => data.active == true);

    const projectOptions = (filteredProjectData || []).map(p => ({
        value: p.projectId,
        label: p.projectName,
        projectType: p.projectType, // optional, if you want it later
    }));

    const portfolioOptions = (portfolioData?.data || []).map(p => ({
        value: p.portfolioName,
        label: p.portfolioName,
        projectType: p.portFolioType,
    }));

    const portfolioSelectOptions = useMemo(
        () => [
            { projectType: "all", label: "All Portfolio" },
            ...portfolioOptions,
        ],
        [portfolioOptions]
    );

    const safeProjectId =
        projectId && projectId !== "undefined" && projectId !== "null"
            ? projectId
            : undefined;

    const safeProjectType =
        projectType && projectType !== "undefined" && projectType !== "null"
            ? projectType
            : undefined;

    // Prefer projectId if both exist, else fallback to projectType

    const [
        triggerStatusByProject,
        actionTrackerStatusByProject
    ] = useLazyGetActionTrackerStatusCountQuery();

    const [
        triggerStatusByType,
        actionTrackerStatusByType
    ] = useLazyGetActionTrackerStatusCountByTypeQuery();

    useEffect(() => {
        if (!actionTrackerList) return;

        const countPayload = {
            ...filters,
        };

        if (safeProjectId) {
            triggerStatusByProject({ ...countPayload, projectId: safeProjectId });
        } else if (safeProjectType) {
            triggerStatusByType({ ...countPayload, projectType: safeProjectType });
        } else {
            triggerStatusByType({ ...countPayload, projectType: "all" });
        }

    }, [actionTrackerList]);

    // const actionTrackerStatusByProject = useGetActionTrackerStatusCountQuery(
    //     safeProjectId ? { projectId: safeProjectId } : skipToken
    // );

    // const actionTrackerStatusByType = useGetActionTrackerStatusCountByTypeQuery(
    //     !safeProjectId && safeProjectType ? { projectType: safeProjectType } : skipToken
    // );


    // Use whichever one ran
    // const actionTrackerStatus = actionTrackerStatusByProject?.data ? actionTrackerStatusByProject : actionTrackerStatusByType;

    const actionTrackerStatus =
        actionTrackerStatusByProject?.data
            ? actionTrackerStatusByProject
            : actionTrackerStatusByType;


    const contactListRes = useGetAllContactsQuery();

    const { data: statusDate } = useGetLastUpdatedOnStatusQuery({ ProjectId: projectId });


    useEffect(() => {
        if (contactListRes?.isSuccess) {
            const contacts = contactListRes?.data?.data || [];
            setActionContact(
                mapAndSortAlphabetically(contacts, "name", "email")
            );
            // setActionContact(
            //     contactListRes?.data?.data?.map(item => ({
            //         value: item?.email,
            //         label: item?.name
            //     }))
            // );
        }
    }, [contactListRes])

    const [triggerExport, { isFetching: isExporting }] = useLazyGetExportAllActionTrackerQuery();

    const handleExportExcel = async () => {
        try {
            const exportFilters = {
                ...filters,
                PageNumber: 1,
                PageSize: 5000,
            };

            const response = await triggerExport(exportFilters).unwrap();

            const rows = response?.data || [];

            if (!Array.isArray(rows) || rows.length === 0) {
                openNotification("No data available to export", "warning");
                return;
            }

            const formattedData = rows.map((row, index) => ({
                "S.No": index + 1,
                "ID": row.customId || "-",
                "Project Name": row.projectName || "-",
                "Sub Project": row.subProject || "-",
                "Description": row.description || "-",
                "Status": row.status || "-",
                "Category": row.topic || "-",
                "Due Date": row.dueDate && moment(row.dueDate).isValid()
                    ? moment(row.dueDate).format(DEFAULT_DATE_FORMAT)
                    : '-',
                "Revised Due Date": row.revisedDueDate && moment(row.revisedDueDate).isValid()
                    ? moment(row.revisedDueDate).format(DEFAULT_DATE_FORMAT)
                    : '-',
                "Comment": row.lastComment || "-",
                "Priority": row.priority || "-",
                "Sources": row.source || "-",
                "Assignee": row.assignedTo || "-",
                "Assignee Name": row.assignedToName || "-",
                "Created At": row.createdDate && moment(row.createdDate).isValid()
                    ? moment(row.createdDate).format(DEFAULT_DATE_FORMAT)
                    : '-',
                "Last Updated At": row.updateDate && moment(row.updateDate).isValid()
                    ? moment(row.updateDate).format(DEFAULT_DATE_FORMAT)
                    : '-',
            }));

            exportToExcel(formattedData, "Action_Tracker_Data");
            openNotification("Excel exported successfully", "success");
        } catch (error) {
            openNotification("Failed to export Excel", "error");
        }
    };

    const handlePageChange = (newPage) => {
        setPageNumber(newPage);
        const updatedFilters = {
            ...filters,
            PageNumber: newPage,
        };
        setFilters(updatedFilters);
        trigger(updatedFilters);
    };

    const handlePageSizeChange = (newSize) => {
        setPageSize(newSize);
        setPageNumber(1);
        const updatedFilters = {
            ...filters,
            PageSize: newSize,
            PageNumber: 1,
        };
        setFilters(updatedFilters);
        trigger(updatedFilters);
    };

    // const handleCheckboxChange = (event) => {

    //     const updatedFilters = {
    //         ...filters,
    //         PendingApproval: event.target.checked,
    //     };
    //     setFilters(updatedFilters);

    // };

    useEffect(() => {
        trigger(filters);
    }, []);

    useEffect(() => {
        const delayDebounceFn = setTimeout(() => {
            if (searchText !== filters.SearchText) {
                const updatedFilters = {
                    ...filters,
                    SearchText: searchText,
                    PageNumber: 1,
                };
                setFilters(updatedFilters);
                trigger(updatedFilters);
                // setCurrentPage(1);
            }
        }, 500);
        return () => clearTimeout(delayDebounceFn);
    }, [searchText]);

    const handleTabChange = (event, newValue) => {
        setTabValue(newValue)
        const updatedFilters = {
            ...filters,
            PageNumber: 1,
            PendingApproval: newValue === filteredtabs.length - 1,
            ...(newValue > 0 && newValue !== filteredtabs.length - 1 ? { Status: actionStatus[newValue - 1]?.value } : {}),
        };

        if ((newValue === 0 || newValue === filteredtabs.length - 1) && updatedFilters.Status) {
            delete updatedFilters.Status;
        }
        setFilters(updatedFilters);
        trigger(updatedFilters);
        // actionTrackerList?.refetch();
    };


    const handleApplyFilters = () => {
        if (tabValue === filteredtabs.length - 1) {
            trigger({ ...filters, PendingApproval: true, PageNumber: 1 });
            setIsApplyFIlter(true);
            setOpen(false);
        }
        else {
            trigger({ ...filters, PageNumber: 1 });
            setIsApplyFIlter(true);
            setOpen(false);
        }

    };

    const handleReset = () => {
        const resetFilters = {
            ProjectId: projectId == undefined ? null : projectId,
            SortBy: sortBy,
            SortOrder: sortOrder,
            PageNumber: 1,
            PageSize: 10,
            SearchText: "",
            ProjectType: projectType,
            ShowOverdueOnly: false,
        };

        if (tabValue === filteredtabs.length - 1) {
            resetFilters.PendingApproval = true;
        }
        setFilters(resetFilters);
        trigger(resetFilters);
        setIsApplyFIlter(false);
        // handleClose();
    };
    const handleProjectChange = (option) => {
        // console.log(option?.value);
        let pid = null;
        if (option?.value) {
            pid = option?.value
        }
        // const pid = option?.value || "";
        // console.log(pid);

        // 1) store selected project id
        setSelectedProjectId(pid);

        // 2) also store in filters so chips / apply uses it later

        let modifidesValues = {
            ...filters,
            ProjectId: pid
        }
        setFilters(modifidesValues);

        // setFilters((prev) => ({
        //     ...prev,
        //     ProjectId: pid,
        // }));

        if (!pid) {
            actionTrackerStatusByProject?.reset();
            triggerStatusByType({ projectType: safeProjectType });
        } else {
            triggerStatusByProject({ projectId: pid });
        }

        // 3) fetch ONLY by projectId
        trigger(modifidesValues);   // <-- nothing else
    };

    const handlePortfolioChange = (option) => {
        let projectType = option?.projectType || "all";
        setProjectType(projectType);
        localStorage.setItem("projectType", projectType)
        let modifidesValues = {
            ...filters,
            ProjectType: projectType,
            ProjectId: null
        }
        setFilters(modifidesValues);
        actionTrackerStatusByProject?.reset();
        triggerStatusByType({ projectType: projectType });
        trigger(modifidesValues);

    };

    const handleSelectChange = (selectedOption, fieldName) => {
        setFilters((prev) => ({
            ...prev,
            [fieldName]: selectedOption?.value || "",
        }));
    }

    const handleInputChange = (e) => {
        setFilters((prev) => ({
            ...prev,
            [e.target.name]: e.target.value,
        }));
    }

    const handleRequestSort = (property) => {
        const isAsc = sortBy === property && sortOrder === 'asc';
        const updatedFilters = {
            ...filters,
            SortBy: property,
            SortOrder: isAsc ? 'desc' : 'asc'

        };
        setFilters(updatedFilters);
        setSortOrder(isAsc ? 'desc' : 'asc');
        setSortBy(property);
        trigger(updatedFilters);

    };

    const handleClick = () => {
        console.info(`You clicked`);
    };

    const handleDelete = (fieldName) => {
        let defaultValue = "";

        if (fieldName === "ShowOverdueOnly") {
            defaultValue = false;
        }
        else if (fieldName === "PendingApproval") {

            const isPendingTab = tabValue === filteredtabs.length - 1;
            defaultValue = isPendingTab ? true : false;
        }
        const updatedFilters = {
            ...filters,
            [fieldName]: defaultValue,
            PageNumber: 1,
            PageSize: 10,
        };


        setFilters(updatedFilters);
        trigger(updatedFilters);
    };

    const handleRefresh = () => {
        const resetFilters = {
            ProjectId: projectId == undefined ? null : projectId,
            SortBy: sortBy,
            SortOrder: sortOrder,
            PageNumber: 1,
            PageSize: 10,
            ProjectType: projectType,
            ShowOverdueOnly: false,
        };

        setFilters(resetFilters);
        trigger(resetFilters);
    }

    const handleMenuItemClick = (event, index) => {
        setSelectedIndex(index);
        setOpen(false);
    };

    const handleSearchChange = (e) => {
        setSearchText(e.target.value);
    };

    const handleToggle = () => {
        setOpen((prevOpen) => !prevOpen);
    };

    const handleClose = (event) => {
        if (anchorRef.current && anchorRef.current.contains(event.target)) {
            return;
        }

        setOpen(false);
    };

    const tabs = ["All", ...actionStatus?.map((item) => item?.value),]
    const adminTabs = ["All", ...actionStatus?.map((item) => item?.value), "Due Date Change Request"]
    const isAdmin = usePermission()
    const filteredtabs = isAdmin ? adminTabs : tabs;

    const highlightText = (text, highlight) => {
        if (!highlight || !text) return text;

        const regex = new RegExp(`(${highlight})`, 'gi');
        const parts = String(text).split(regex);

        return parts.map((part, index) =>
            regex.test(part) ? (
                <span
                    key={index}
                    style={{
                        backgroundColor: '#FFF3CD',
                        color: '#856404',
                        fontWeight: 'bold',
                        padding: '0 2px',
                        borderRadius: '3px'
                    }}
                >
                    {part}
                </span>
            ) : part
        );
    };



    const columns = [
        {
            name: "",
            field: "actions",
            width: "10px",
            sticky: true,
            renderer: (row) => (
                <>
                    {(viewAccess || editAccess || deleteAccess) &&
                        <Box sx={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
                            <IconButton
                                size="small"
                                onClick={(e) => handleMenuOpen(e, row)}
                            >
                                <MoreVertIcon fontSize="small" />
                            </IconButton>
                        </Box>}
                </>
            ),
        },
        {
            name: "ID",
            field: "customId",
            width: "130px",
            sticky: true,
            renderer: (row) => (
                <Box sx={{ display: "flex", alignItems: "center", gap: "10px" }}>
                    <Avatar
                        sx={{
                            width: 30,
                            height: 30,
                            bgcolor: getStatusColor(row).bg,
                            color: getStatusColor(row).text,
                            fontSize: "14px",
                            textTransform: "uppercase",
                        }}
                    >
                        {getDelayAvatar(row)}
                        {/* {row?.customId?.[0] || "?"} */}
                    </Avatar>

                    <Typography
                        sx={{
                            fontSize: "16px",
                            fontWeight: 500,
                            fontFamily: "Outfit",
                            color: "#433F5E",
                            maxWidth: "140px",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            whiteSpace: "nowrap",
                        }}
                    >
                        {row?.customId}
                    </Typography>
                </Box>
            )
        },
        {
            name: "Description",
            field: "description",
            width: "300px",
            sticky: true,
            renderer: (row) => highlightText(row?.description, searchText)
        },
        {
            name: "Project",
            field: "projectName",
            width: "200px",
        },
        {
            name: "Sub Project",
            field: "subProject",
            width: "200px",
        },
        {
            name: 'Status',
            field: 'status',
            renderer: (row) => (
                <StatusBadge status={row.status} />
            )
        },
        {
            name: "Category",
            field: "topic",
            // width: "45%",
            renderer: (row) => highlightText(row?.topic, searchText)
        },
        {
            name: "Due Date",
            field: 'dueDate',
            renderer: (row) => (
                <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
                    {row?.revisedDueDate ?
                        <>
                            <DueDateCell row={row} />
                            {(() => {
                                // 1. Get raw date values first for accurate comparison
                                const rawDates = [row?.dueDate, ...(row?.revisedDueDateHistory || [])]
                                    .filter(Boolean);

                                // 2. Format them for display
                                const formattedDates = rawDates.map(val => moment(val).format(DEFAULT_DATE_FORMAT));

                                // 3. Get unique display dates, keeping the last two
                                const uniqueDates = [...new Set(formattedDates)].slice(-2);

                                return uniqueDates.map((val, ind, arr) => {
                                    const isLast = ind === arr.length - 1;
                                    const currentDate = new Date(val);
                                    const today = new Date();
                                    let isGreaterThanCurrent = false;
                                    if (isLast) {
                                        isGreaterThanCurrent = currentDate > today;
                                    }

                                    return (
                                        <Chip
                                            key={val}
                                            label={val}
                                            sx={{
                                                textDecoration: isLast ? "none" : "line-through",
                                                color: isLast ? (isGreaterThanCurrent ? "#34A853" : "#e51c1cff") : "#e51c1cff",
                                                backgroundColor: isLast ? (isGreaterThanCurrent ? "#E1FFBB" : "#f5ccccff") : "#f5ccccff",
                                                fontWeight: 500,
                                                height: "20px",
                                                borderRadius: "3px",
                                                padding: "2px 6px",
                                                fontFamily: "Outfit",
                                                fontSize: "12px",
                                                marginRight: "5px",
                                            }}
                                        />
                                    );
                                });
                            })()}
                            {/* {(() => {
                                // 1. Combine and format all dates first
                                const allDates = [row?.dueDate, ...(row?.revisedDueDateHistory || [])]
                                    .filter(Boolean) // Remove null/undefined
                                    .map(val => moment(val).format(DEFAULT_DATE_FORMAT));

                                // 2. Filter for unique values while preserving order, then take last 2
                                const uniqueDates = [...new Set(allDates)].slice(-2);

                                return uniqueDates.map((val, ind, arr) => {
                                    const isLast = ind === arr.length - 1;

                                    return (
                                        <Chip
                                            key={val} // Using the date string as a key is safer than index
                                            label={val}
                                            sx={{
                                                textDecoration: isLast ? "none" : "line-through",
                                                color: isLast ? "#34A853" : "#e51c1cff",
                                                backgroundColor: isLast ? "#E1FFBB" : "#f5ccccff",
                                                fontWeight: 500,
                                                height: "20px",
                                                borderRadius: "3px",
                                                padding: "2px 6px",
                                                fontFamily: "Outfit",
                                                fontSize: "12px",
                                                marginRight: "5px",
                                            }}
                                        />
                                    );
                                });
                            })()} */}
                        </>
                        :
                        <>
                            {moment(row?.dueDate).isValid() ?
                                <Chip
                                    label={moment(row?.dueDate).format(DEFAULT_DATE_FORMAT)}
                                    sx={{
                                        // textDecoration: "line-through",
                                        color: getStatusColor(row).text,
                                        backgroundColor: getStatusColor(row).bg,
                                        fontWeight: 500,
                                        height: "20px",
                                        borderRadius: "3px",
                                        padding: "2px 6px",
                                        fontFamily: "Outfit",
                                        fontSize: "12px",
                                        marginRight: "5px",
                                    }}
                                />
                                : '-'
                            }

                        </>
                    }
                </Box>
            ),
        },
        // {
        //     name: "Due Date",
        //     field: "dueDate",
        //     // width: "10%",
        //     renderer: ({ dueDate }) =>
        //         dueDate && moment(dueDate).isValid()
        //             ? moment(dueDate).format(DEFAULT_DATE_FORMAT)
        //             : '-'
        // },
        {
            name: "Comment",
            field: "lastComment",
            width: '300px',
            renderer: (row) => (
                <Box sx={{ whiteSpace: "pre-line" }}>
                    {row?.lastComment ? row?.lastComment : '-'}
                </Box>
            ),
        },

        {
            name: "Priority",
            field: "priority",
            // width: "7%",
        },
        {
            name: "Sources",
            field: "source",
            renderer: (row) => (
                <>
                    {row?.source ? row?.source : '-'}
                </>
            ),
            // width: "15%",
        },
        {
            name: "Assignee",
            field: "assignedToName",
            // width: "25%",
            renderer: (row) => (
                <>
                    {row?.assignedToName?.split(',')?.map((val, key) => (
                        <Typography key={key} sx={{ fontSize: "16px", fontWeight: 500, color: "#433F5E" }}>
                            {val}
                        </Typography>
                    ))}
                </>
            ),
        },
        {
            name: "Created at",
            field: "createdDate",
            // width: "10%",
            renderer: ({ createdDate }) =>
                createdDate && moment(createdDate).isValid()
                    ? moment(createdDate).format(DEFAULT_DATE_FORMAT)
                    : '-'
        },
        {
            name: "Last Updated at",
            field: "updateDate",
            // width: "10%",
            renderer: ({ updateDate }) =>
                updateDate && moment(updateDate).isValid()
                    ? moment(updateDate).format(DEFAULT_DATE_FORMAT)
                    : '-'
        },
    ];

    const handleEditTracker = (row) => {
        setIsEditTracker((prev) => {
            const newState = !prev;
            setRowData(newState ? row : null);
            return newState;
        });
    }

    const handleViewClick = (row) => {
        setIsViewTracker((prev) => {
            const newState = !prev;
            setRowData(newState ? row : null);
            return newState;
        });
    }

    const handleAddActionTracker = () => {
        setIsAddActionTracker(!isAddActionTracker);
    }
    const [showSummary, setShowSummary] = useState(true);

    const handleToggleSummary = () => {
        setShowSummary((prev) => !prev);
    };

    const openNotification = (msg, type = "error", duration = 3000) => {
        dispatch(
            openSnackbar({
                open: true,
                message: msg,
                variant: 'alert',
                alert: {
                    color: type
                },
                close: false
            })
        );
        setTimeout(() => dispatch(closeSnackbar()), duration);
    };

    const confirmationDeleteDialog = () => (
        <Dialog
            open={isDeleteModal}
            fullWidth
            maxWidth="md"
            PaperProps={{
                sx: { borderTopLeftRadius: "3px", borderTopRightRadius: "3px", backgroundColor: "#FFFFFF", width: "100%", overflowX: "hidden" },
            }}
            disableEscapeKeyDown
            onClose={(event, reason) => {
                if (reason !== "backdropClick") {
                    // handleClose();
                }
            }}
        >
            <DialogTitle sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                borderBottom: "1px solid #ddd",
                backgroundColor: "#FFFFFF",
                pb: 2,
                pt: 2,
                width: "100%",
            }}><Typography sx={{ fontWeight: 600, fontSize: "18px", lineHeight: "100%", color: "#140F36", fontFamily: "Outfit, sans-serif" }}>
                    Delete Action Tracker
                </Typography>
                <IconButton
                    aria-label="close"
                    onClick={() => handleDeleteActionTracker()}
                    sx={(theme) => ({
                        position: "absolute",
                        right: 8,
                        top: 8,
                        color: theme.palette.grey[500],
                    })}
                >
                    {/* <IoMdClose style={{ fontSize: "20px" }} /> */}
                    <RxCross2 style={{ fontSize: "30px", color: "#140F36" }} />
                </IconButton>
            </DialogTitle>
            <DialogContent sx={{ padding: '24px !important' }}>
                <DialogContentText sx={{ fontWeight: 400, fontSize: '16px', color: '#474747', fontFamily: "Outfit, sans-serif" }}>
                    Are you sure you want to Delete this action tracker ? This action is permanent.
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <CustomButton
                    label="Delete"
                    startIcon={<MdDeleteOutline />}
                    onClick={handleConfirmationDelete}
                    loading={actionDeleteRes?.isLoading}
                    sx={{
                        backgroundColor: "#00344C",
                        fontFamily: 'Outfit',
                        fontWeight: 500,
                        fontSize: '14px',
                        lineHeight: '100%',
                        letterSpacing: '0px',
                    }}
                />
            </DialogActions>
        </Dialog>
    );

    return (
        <>
            {confirmationDeleteDialog()}
            <EnterprisePageShell
                eyebrow="Execution Workbench"
                title="Action tracker command board"
                description="Manage open actions, due-date exposure, owners, approvals, and closure velocity from a single operations view."
                actions={createAccess && (
                    <CustomButton
                        label="Create Action"
                        startIcon={<FaPlus />}
                        color="primary"
                        onClick={handleAddActionTracker}
                        sx={{
                            height: 36,
                            borderRadius: "3px",
                            fontWeight: 650,
                        }}
                    />
                )}
                meta={
                    <>
                        {filteredtabs?.slice(0, 4)?.map((label, index) => (
                            <Box key={label} sx={{ px: 1.25, py: 0.75, borderRadius: "3px", background: enterpriseTokens.surfaceAlt, border: `1px solid ${enterpriseTokens.lineSoft}`, minWidth: 100 }}>
                                <Typography sx={{ color: enterpriseTokens.muted, fontSize: 10, fontWeight: 650, textTransform: "uppercase" }}>{label}</Typography>
                                <Typography sx={{ color: enterpriseTokens.navy, fontSize: 17, fontWeight: 650 }}>
                                    {index === 0 ? actionTrackerList?.totalRecords || 0 : actionTrackerStatus?.data?.data?.statusCounts[label] ?? "0"}
                                </Typography>
                            </Box>
                        ))}
                    </>
                }
            >
            <Grid container spacing={2}>
                <Grid size={8} sx={{ flex: 1 }} container alignItems="center" justifyContent="space-between">
                    <Box sx={{ display: "flex", alignItems: "center", gap: 1.5, flexWrap: "wrap" }}>
                        <Typography sx={{ fontSize: 15, fontWeight: 650, color: enterpriseTokens.navy }}>
                            Operational controls
                        </Typography>
                        {statusDate?.projectAction && <ProjectLastUpdatedOn date={statusDate?.projectAction} />}
                    </Box>
                </Grid>

                {projectId == undefined && <Grid size={2}>
                    <Grid size={12}>
                        <Select
                            name="portfolios"
                            options={portfolioSelectOptions}
                            value={
                                portfolioSelectOptions.find(
                                    (opt) => opt.projectType === filters?.ProjectType
                                ) || null
                            }
                            onChange={(option) => handlePortfolioChange(option)}
                            placeholder="Select Portfolio"
                        />
                    </Grid>
                </Grid>}

                {projectId == undefined &&
                    <Grid size={2}>
                        <Grid size={12}>
                            <Select
                                name="projects"
                                options={[{ value: null, label: "All Projects" }, ...projectOptions]}
                                value={[{ value: null, label: "All Projects" }, ...projectOptions].find(opt => opt.value === filters?.ProjectId) || null}
                                onChange={(option) => handleProjectChange(option, "ProjectId")}
                                placeholder="Select Project"
                            />
                            {/* <Select
                        name="topic"
                        options={actionCategories}
                        placeholder="Select Category"
                        onChange={(option) => handleSelectChange(option, "Topic")}
                    /> */}
                        </Grid>
                    </Grid>
                }


                <Grid size={12}>
                    <Button
                        variant="text"
                        onClick={handleToggleSummary}
                        sx={{
                            fontFamily: "Inter, Outfit, sans-serif",
                            textTransform: "none",
                            fontWeight: 600,
                            color: enterpriseTokens.primary,
                            border: `1px solid ${enterpriseTokens.lineSoft}`,
                            backgroundColor: "#FFFFFF",
                            borderRadius: "3px",
                            minHeight: 34,
                            px: 1.5,
                        }}
                    >
                        {showSummary ? "Hide Summary" : "Show Summary"}
                    </Button>
                </Grid>
                <Grid size={12}>
                    <Collapse in={showSummary} timeout="auto" unmountOnExit>
                        <Grid container spacing={2}>
                            <Grid size={{ md: 3, sm: 12, xs: 12 }}>
                                <ActionCategoryChart categoryWiseStats={actionTrackerStatus?.data?.data?.categoryWiseStats} columns={columns} />
                            </Grid>
                            <Grid size={{ md: 3, sm: 12, xs: 12 }}>
                                <ActionPriorityWiseChart priorityWiseStats={actionTrackerStatus?.data?.data?.priorityWiseStats} columns={columns} />
                            </Grid>
                            <Grid size={{ md: 3, sm: 12, xs: 12 }}>
                                <AgeingAnalysisChart data={actionTrackerStatus?.data?.data?.ageingData} columns={columns} />
                            </Grid>
                            <Grid size={{ md: 3, sm: 12, xs: 12 }}>
                                <ThisWeekCloserChart data={actionTrackerStatus?.data?.data?.closedThisWeekStats} columns={columns} />
                            </Grid>
                        </Grid>
                    </Collapse>
                </Grid>
                <Grid size={12}>
                    <Box
                        sx={{
                            width: "100%",
                            border: `1px solid ${enterpriseTokens.lineSoft}`,
                            borderRadius: "3px 3px 0 0",
                            overflowX: "auto",
                            whiteSpace: "nowrap",
                            p: 1.25,
                            backgroundColor: "#FFFFFF",
                            display: "flex", alignItems: "center", justifyContent: 'space-between',
                            "-webkit-overflow-scrolling": "touch",
                        }}
                    >
                        <Tabs
                            value={tabValue}
                            onChange={handleTabChange}
                            TabIndicatorProps={{ style: { display: "none" } }}
                            variant="scrollable"
                            scrollButtons={false}
                            sx={{
                                justifyContent: "flex-start !important",
                                alignItems: "flex-start",
                                "& .MuiTabs-flexContainer": {
                                    justifyContent: "flex-start !important",
                                    gap: "4px",
                                },
                            }}
                        >
                            {filteredtabs?.map((label, index) => (
                                <Tab
                                    key={index}
                                    label={
                                        <Box
                                            sx={{
                                                display: "flex",
                                                alignItems: "center",
                                                gap: "6px",
                                            }}
                                        >
                                            <Typography
                                                sx={{
                                                    fontWeight: 600,
                                                    fontSize: "12px",
                                                    lineHeight: "18px",
                                                    color: tabValue === index ? "#FFFFFF" : enterpriseTokens.slate,
                                                    fontFamily: "Inter, Outfit, sans-serif"
                                                }}
                                            >
                                                {label}
                                            </Typography>
                                            {index != 0 && index !== filteredtabs.length - 1 &&
                                                <Chip
                                                    label={actionTrackerStatus?.data?.data?.statusCounts[label] ?? '0'}
                                                    sx={{
                                                        height: "20px",
                                                        width: "32",
                                                        fontSize: "14px",
                                                        fontWeight: 500,
                                                        lineHeight: 1,
                                                        backgroundColor: tabValue === index ? "rgba(255,255,255,0.18)" : enterpriseTokens.surfaceAlt,
                                                        color: tabValue === index ? "#FFFFFF" : enterpriseTokens.slate,
                                                    }}
                                                />
                                            }

                                        </Box>
                                    }
                                    sx={{
                                        textTransform: "none",
                                        minWidth: "auto",
                                        minHeight: "34px",
                                        px: 1.25,
                                        py: 0.75,
                                        borderRadius: "3px",
                                        backgroundColor: tabValue === index ? enterpriseTokens.surfaceTint : "transparent",
                                        border: `1px solid ${tabValue === index ? enterpriseTokens.line : "transparent"}`,
                                        "& .MuiTypography-root": {
                                            color: tabValue === index ? enterpriseTokens.primary : enterpriseTokens.slate,
                                        },
                                    }}
                                />
                            ))}
                        </Tabs>
                    </Box>
                </Grid>

                <Grid size={12}>
                    <Grid container sx={{ backgroundColor: "#FFFFFF", borderLeft: `1px solid ${enterpriseTokens.lineSoft}`, borderRight: `1px solid ${enterpriseTokens.lineSoft}`, p: 1.5 }}>
                        <Grid size={{ md: 8, sm: 6 }}>
                            {isApplyFilter &&
                                <Stack direction="row" spacing={1}>
                                    {filters?.Topic && (
                                        <Chip
                                            label={
                                                <Typography variant="body2">
                                                    <strong style={{ color: '#0E73F6' }}>Category:</strong>{" "}
                                                    <span style={{ fontWeight: 400, color: "#6B7280" }}>{filters?.Topic}</span>
                                                </Typography>
                                            }
                                            sx={{ backgroundColor: enterpriseTokens.surfaceTint, border: 0, borderRadius: "999px" }}
                                            variant="outlined"
                                            onDelete={() => handleDelete('Topic')}
                                        />
                                    )}
                                    {/* {filters.PendingApproval === true && (
                                        <Chip
                                            label={
                                                <Typography variant="body2">
                                                    <strong style={{ color: '#0E73F6' }}>Pending Approval :</strong>{" "}
                                                    <span style={{ fontWeight: 400, color: "#6B7280" }}>
                                                        True
                                                    </span>
                                                </Typography>
                                            }
                                            sx={{
                                                backgroundColor: "rgba(25, 118, 210, 0.08)",
                                                border: 0
                                            }}
                                            variant="outlined"
                                            onDelete={() => handleDelete('PendingApproval')}
                                        />
                                    )} */}
                                    {filters?.DecisionVsOperational && (
                                        <Chip
                                            label={
                                                <Typography variant="body2">
                                                    <strong style={{ color: '#0E73F6' }}>Decision Vs Operational:</strong>{" "}
                                                    <span style={{ fontWeight: 400, color: "#6B7280" }}>{filters?.DecisionVsOperational}</span>
                                                </Typography>
                                            }
                                            sx={{
                                                backgroundColor: "rgba(25, 118, 210, 0.08)",
                                                border: 0
                                            }}
                                            variant="outlined"
                                            onDelete={() => handleDelete('DecisionVsOperational')}
                                        />
                                    )}
                                    {filters?.Status &&
                                        <Chip
                                            label={
                                                <Typography variant="body2">
                                                    <strong style={{ color: '#0E73F6' }}>Status:</strong>{" "}
                                                    <span style={{ fontWeight: 400, color: "#6B7280" }}>{filters?.Status}</span>
                                                </Typography>
                                            }
                                            sx={{
                                                backgroundColor: "rgba(25, 118, 210, 0.08)",
                                                border: 0
                                            }}
                                            variant="outlined"
                                            onDelete={() => handleDelete('Status')}
                                        />
                                    }
                                    {filters?.Source &&
                                        <Chip
                                            label={
                                                <Typography variant="body2">
                                                    <strong style={{ color: '#0E73F6' }}>Source:</strong>{" "}
                                                    <span style={{ fontWeight: 400, color: "#6B7280" }}>{filters?.Source}</span>
                                                </Typography>
                                            }
                                            sx={{
                                                backgroundColor: "rgba(25, 118, 210, 0.08)",
                                                border: 0
                                            }}
                                            variant="outlined"
                                            onDelete={() => handleDelete('Source')}
                                        />
                                    }
                                    {filters?.Priority &&
                                        <Chip
                                            label={
                                                <Typography variant="body2">
                                                    <strong style={{ color: '#0E73F6' }}>Priority:</strong>{" "}
                                                    <span style={{ fontWeight: 400, color: "#6B7280" }}>{filters?.Priority}</span>
                                                </Typography>
                                            }
                                            sx={{
                                                backgroundColor: "rgba(25, 118, 210, 0.08)",
                                                border: 0
                                            }}
                                            variant="outlined"
                                            onDelete={() => handleDelete('Priority')}
                                        />
                                    }
                                    {filters?.AssignedTo &&
                                        <Chip
                                            label={
                                                <Typography variant="body2">
                                                    <strong style={{ color: '#0E73F6' }}>Assigned To:</strong>{" "}
                                                    <span style={{ fontWeight: 400, color: "#6B7280" }}>{filters?.AssignedTo}</span>
                                                </Typography>
                                            }
                                            sx={{
                                                backgroundColor: "rgba(25, 118, 210, 0.08)",
                                                border: 0
                                            }}
                                            variant="outlined"
                                            onDelete={() => handleDelete('AssignedTo')}
                                        />
                                    }
                                    {filters?.DueDateFrom &&
                                        <Chip
                                            label={
                                                <Typography variant="body2">
                                                    <strong style={{ color: '#0E73F6' }}>Due Date From:</strong>{" "}
                                                    <span style={{ fontWeight: 400, color: "#6B7280" }}>{moment(filters?.DueDateFrom)?.format('DD-MM-YYYY')}</span>
                                                </Typography>
                                            }
                                            sx={{
                                                backgroundColor: "rgba(25, 118, 210, 0.08)",
                                                border: 0
                                            }}
                                            variant="outlined"
                                            onDelete={() => handleDelete('DueDateFrom')}
                                        />
                                    }
                                    {filters?.CreatedDate &&
                                        <Chip
                                            label={
                                                <Typography variant="body2">
                                                    <strong style={{ color: '#0E73F6' }}>Created Date:</strong>{" "}
                                                    <span style={{ fontWeight: 400, color: "#6B7280" }}>{moment(filters?.CreatedDate)?.format('DD-MM-YYYY')}</span>
                                                </Typography>
                                            }
                                            sx={{
                                                backgroundColor: "rgba(25, 118, 210, 0.08)",
                                                border: 0
                                            }}
                                            variant="outlined"
                                            onDelete={() => handleDelete('CreatedDate')}
                                        />
                                    }

                                    {filters?.UpdatedDate &&
                                        <Chip
                                            label={
                                                <Typography variant="body2">
                                                    <strong style={{ color: '#0E73F6' }}>Updated Date:</strong>{" "}
                                                    <span style={{ fontWeight: 400, color: "#6B7280" }}>{moment(filters?.UpdatedDate)?.format('DD-MM-YYYY')}</span>
                                                </Typography>
                                            }
                                            sx={{
                                                backgroundColor: "rgba(25, 118, 210, 0.08)",
                                                border: 0
                                            }}
                                            variant="outlined"
                                            onDelete={() => handleDelete('UpdatedDate')}
                                        />
                                    }
                                    {filters?.ClosedDate &&
                                        <Chip
                                            label={
                                                <Typography variant="body2">
                                                    <strong style={{ color: '#0E73F6' }}>Closed Date:</strong>{" "}
                                                    <span style={{ fontWeight: 400, color: "#6B7280" }}>{moment(filters?.ClosedDate)?.format('DD-MM-YYYY')}</span>
                                                </Typography>
                                            }
                                            sx={{
                                                backgroundColor: "rgba(25, 118, 210, 0.08)",
                                                border: 0
                                            }}
                                            variant="outlined"
                                            onDelete={() => handleDelete('ClosedDate')}
                                        />
                                    }

                                    {filters?.ShowOverdueOnly && (
                                        <Chip
                                            label={
                                                <Typography variant="body2">
                                                    <strong style={{ color: '#0E73F6' }}>
                                                        Delayed Task: Yes
                                                    </strong>
                                                </Typography>
                                            }
                                            sx={{
                                                backgroundColor: "rgba(25, 118, 210, 0.08)",
                                                border: 0
                                            }}
                                            variant="outlined"
                                            onDelete={() => handleDelete("ShowOverdueOnly")}
                                        />
                                    )}

                                    {filters?.SubProject &&
                                        <Chip
                                            label={
                                                <Typography variant="body2">
                                                    <strong style={{ color: '#0E73F6' }}>Sub Project:</strong>{" "}
                                                    <span style={{ fontWeight: 400, color: "#6B7280" }}>{filters?.SubProject}</span>
                                                </Typography>
                                            }
                                            sx={{
                                                backgroundColor: "rgba(25, 118, 210, 0.08)",
                                                border: 0
                                            }}
                                            variant="outlined"
                                            onDelete={() => handleDelete('SubProject')}
                                        />
                                    }

                                </Stack>
                            }
                        </Grid>
                        <Grid size={{ md: 4, sm: 6 }}>
                            <Box
                                sx={{
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: 'end'
                                    // borderLeft: "1px solid #E5E9EB",
                                    // borderRight: "1px solid #E5E9EB",
                                }}
                            >
                                <TextField
                                    placeholder="Search By Description & Category"
                                    value={searchText}
                                    onChange={handleSearchChange}
                                    variant="outlined"
                                    size="small"
                                    InputProps={{
                                        startAdornment: <LuSearch style={{ marginRight: '8px', color: '#6B7280' }} />,
                                    }}
                                    sx={{
                                        minWidth: '250px',
                                        width: "100%",
                                        backgroundColor: '#fff',
                                        borderRadius: '3px',
                                        '& .MuiOutlinedInput-root': { borderRadius: '3px' },
                                        '& .MuiInputBase-input::placeholder': {
                                            fontSize: '0.9rem',
                                        }
                                    }}
                                    type="search"
                                />
                                <IconButton
                                    ref={anchorRef}
                                    onClick={handleToggle}
                                >
                                    <MdOutlineFilterAlt size={24} color="#48535B" />
                                </IconButton>
                                <Popper
                                    open={open}
                                    anchorEl={anchorRef.current}
                                    placement="bottom-end"
                                    transition
                                    disablePortal={false}
                                    sx={{ zIndex: 2000 }}
                                    onClick={(e) => e.stopPropagation()}
                                >
                                    {({ TransitionProps }) => (
                                        <Grow {...TransitionProps}>
                                            <Paper
                                                sx={{
                                                    mt: 1,
                                                    p: 2,
                                                    borderRadius: 1,
                                                    boxShadow: "0px 4px 20px rgba(7, 7, 7, 0.08)",
                                                    width: 600,
                                                }}
                                            >
                                                <ClickAwayListener onClickAway={handleClose}>

                                                    <Box
                                                        sx={{
                                                            maxHeight: "50vh",   // popup max height
                                                            overflowY: "auto",
                                                            overflowX: "hidden",
                                                            p: 2,
                                                            borderRadius: "3px",
                                                        }}
                                                    >
                                                        {open && (
                                                            <Grid container spacing={2}>
                                                                <Grid size={6}>
                                                                    <Typography sx={{
                                                                        fontFamily: 'Outfit',
                                                                        fontWeight: 500,
                                                                        fontSize: '16px',
                                                                        lineHeight: '100%',
                                                                        letterSpacing: "0px",
                                                                        mb: 1
                                                                    }}>Select Category</Typography>
                                                                    <Select
                                                                        name="topic"
                                                                        options={actionCategories}
                                                                        isClearable
                                                                        value={actionCategories.find(opt => opt.value === filters?.Topic) || null}
                                                                        onChange={(option) => handleSelectChange(option, "Topic")}
                                                                        placeholder="Select Category"
                                                                    />
                                                                    {/* <Select
                                                                    name="topic"
                                                                    options={actionCategories}
                                                                    placeholder="Select Category"
                                                                    onChange={(option) => handleSelectChange(option, "Topic")}
                                                                /> */}
                                                                </Grid>
                                                                <Grid size={6}>
                                                                    <Typography sx={{
                                                                        fontFamily: 'Outfit',
                                                                        fontWeight: 500,
                                                                        fontSize: '16px',
                                                                        lineHeight: '100%',
                                                                        letterSpacing: "0px",
                                                                        mb: 1
                                                                    }}>
                                                                        Select Decision Vs Operational
                                                                    </Typography>
                                                                    <Select
                                                                        name="decisionVsOperational"
                                                                        options={actionDecisionVsOperational}
                                                                        isClearable
                                                                        value={actionDecisionVsOperational.find(opt => opt.value === filters?.DecisionVsOperational) || null}
                                                                        onChange={(option) => handleSelectChange(option, "DecisionVsOperational")}
                                                                        // onBlur={() => setFieldTouched("decisionVsOperational", true)}
                                                                        placeholder="Select Decision Vs Operational"
                                                                    />
                                                                </Grid>
                                                                <Grid size={6}>
                                                                    <Typography sx={{
                                                                        fontFamily: 'Outfit',
                                                                        fontWeight: 500,
                                                                        fontSize: '16px',
                                                                        lineHeight: '100%',
                                                                        letterSpacing: "0px",
                                                                        mb: 1
                                                                    }}>Select Priority</Typography>
                                                                    <Select
                                                                        name="Priority"
                                                                        options={actionPriority}
                                                                        isClearable
                                                                        value={actionPriority.find(opt => opt.value === filters.Priority) || null}
                                                                        onChange={(option) => handleSelectChange(option, "Priority")}
                                                                        placeholder="Select Priority"
                                                                    />
                                                                </Grid>


                                                                <Grid size={6}>
                                                                    <Typography sx={{
                                                                        fontFamily: 'Outfit',
                                                                        fontWeight: 500,
                                                                        fontSize: '16px',
                                                                        lineHeight: '100%',
                                                                        letterSpacing: "0px",
                                                                        mb: 1
                                                                    }}>Select Source</Typography>
                                                                    <Select
                                                                        name="Source"
                                                                        options={actionSource}
                                                                        isClearable
                                                                        value={actionSource.find(opt => opt.value === filters.Source) || null}
                                                                        onChange={(option) => handleSelectChange(option, "Source")}
                                                                        placeholder="Select Source"
                                                                    />
                                                                </Grid>
                                                                <Grid size={6}>
                                                                    <Typography sx={{
                                                                        fontFamily: 'Outfit',
                                                                        fontWeight: 500,
                                                                        fontSize: '16px',
                                                                        lineHeight: '100%',
                                                                        letterSpacing: "0px",
                                                                        mb: 1
                                                                    }}>Select Status</Typography>
                                                                    <Select
                                                                        name="status"
                                                                        placeholder="Select Status"
                                                                        value={actionStatus.find(opt => opt.value === filters?.Status) || null}
                                                                        onChange={(option) => handleSelectChange(option, "Status")}
                                                                        options={actionStatus}
                                                                        isClearable
                                                                    />
                                                                </Grid>
                                                                <Grid size={6}>
                                                                    <Typography sx={{
                                                                        fontFamily: 'Outfit',
                                                                        fontWeight: 500,
                                                                        fontSize: '16px',
                                                                        lineHeight: '100%',
                                                                        letterSpacing: "0px",
                                                                        mb: 1
                                                                    }}>Due Date From</Typography>
                                                                    <TextField
                                                                        type="date"
                                                                        name="due_date"
                                                                        value={filters?.DueDateFrom || ""}
                                                                        // onBlur={handleBlur}
                                                                        onChange={(e) => {
                                                                            const selectedDate = e.target.value;

                                                                            setFilters((prev) => ({
                                                                                ...prev,
                                                                                DueDateFrom: selectedDate,
                                                                            }));
                                                                        }}
                                                                        onClick={(e) => {
                                                                            // Trigger the native date picker
                                                                            const input = e.currentTarget.parentElement?.querySelector('input[type="date"]');
                                                                            if (input) input.showPicker?.();
                                                                        }}
                                                                        fullWidth
                                                                        sx={{
                                                                            // ...rightTextStyle,
                                                                            "& input::-webkit-calendar-picker-indicator": {
                                                                                display: "none",
                                                                                WebkitAppearance: "none",
                                                                            },
                                                                            "& input[type='date']": {
                                                                                appearance: "none",
                                                                                WebkitAppearance: "none",
                                                                            },
                                                                            "& .MuiOutlinedInput-root": {
                                                                                "& fieldset": {
                                                                                    border: "none",
                                                                                },
                                                                            },
                                                                        }}
                                                                        InputProps={{
                                                                            startAdornment: (
                                                                                <Box sx={{ ml: 2, mr: 1, color: "#433F5E", display: "flex", alignItems: "center", cursor: "pointer" }}

                                                                                >
                                                                                    {calenderSVG}
                                                                                </Box>
                                                                            ),
                                                                            sx: {
                                                                                backgroundColor: "#E7E7EB",
                                                                                height: "40px",
                                                                                width: { xs: "100%", md: "100%" },
                                                                                borderRadius: "3px",
                                                                            },
                                                                        }}
                                                                    />
                                                                </Grid>
                                                                <Grid size={6}>
                                                                    <Typography sx={{
                                                                        fontFamily: 'Outfit',
                                                                        fontWeight: 500,
                                                                        fontSize: '16px',
                                                                        lineHeight: '100%',
                                                                        letterSpacing: "0px",
                                                                        mb: 1
                                                                    }}>Assigned To</Typography>
                                                                    <Select
                                                                        name="AssignedTo"
                                                                        placeholder="Select Assigned To"
                                                                        value={actionContact.find(opt => opt.value === filters?.AssignedTo) || null}
                                                                        onChange={(option) => handleSelectChange(option, "AssignedTo")}
                                                                        options={actionContact}
                                                                        isClearable
                                                                    />

                                                                </Grid>
                                                                <Grid size={6}>
                                                                    <Typography sx={{
                                                                        fontFamily: 'Outfit',
                                                                        fontWeight: 500,
                                                                        fontSize: '16px',
                                                                        lineHeight: '100%',
                                                                        letterSpacing: "0px",
                                                                        mb: 1
                                                                    }}>Created Date</Typography>
                                                                    <TextField
                                                                        type="date"
                                                                        name="created_date"
                                                                        value={filters?.CreatedDate || ""}
                                                                        // onBlur={handleBlur}
                                                                        onChange={(e) => {
                                                                            const selectedDate = e.target.value;

                                                                            setFilters((prev) => ({
                                                                                ...prev,
                                                                                CreatedDate: selectedDate,
                                                                            }));
                                                                        }}
                                                                        onClick={(e) => {
                                                                            // Trigger the native date picker
                                                                            const input = e.currentTarget.parentElement?.querySelector('input[type="date"]');
                                                                            if (input) input.showPicker?.();
                                                                        }}
                                                                        fullWidth
                                                                        sx={{
                                                                            // ...rightTextStyle,
                                                                            "& input::-webkit-calendar-picker-indicator": {
                                                                                display: "none",
                                                                                WebkitAppearance: "none",
                                                                            },
                                                                            "& input[type='date']": {
                                                                                appearance: "none",
                                                                                WebkitAppearance: "none",
                                                                            },
                                                                            "& .MuiOutlinedInput-root": {
                                                                                "& fieldset": {
                                                                                    border: "none",
                                                                                },
                                                                            },
                                                                        }}
                                                                        InputProps={{
                                                                            startAdornment: (
                                                                                <Box sx={{ ml: 2, mr: 1, color: "#433F5E", display: "flex", alignItems: "center", cursor: "pointer" }}

                                                                                >
                                                                                    {calenderSVG}
                                                                                </Box>
                                                                            ),
                                                                            sx: {
                                                                                backgroundColor: "#E7E7EB",
                                                                                height: "40px",
                                                                                width: { xs: "100%", md: "100%" },
                                                                                borderRadius: "3px",
                                                                            },
                                                                        }}
                                                                    />
                                                                </Grid>
                                                                <Grid size={6}>
                                                                    <Typography sx={{
                                                                        fontFamily: 'Outfit',
                                                                        fontWeight: 500,
                                                                        fontSize: '16px',
                                                                        lineHeight: '100%',
                                                                        letterSpacing: "0px",
                                                                        mb: 1
                                                                    }}>Updated Date</Typography>
                                                                    <TextField
                                                                        type="date"
                                                                        name="updated_date"
                                                                        value={filters?.UpdatedDate || ""}
                                                                        // onBlur={handleBlur}
                                                                        onChange={(e) => {
                                                                            const selectedDate = e.target.value;

                                                                            setFilters((prev) => ({
                                                                                ...prev,
                                                                                UpdatedDate: selectedDate,
                                                                            }));
                                                                        }}
                                                                        onClick={(e) => {
                                                                            // Trigger the native date picker
                                                                            const input = e.currentTarget.parentElement?.querySelector('input[type="date"]');
                                                                            if (input) input.showPicker?.();
                                                                        }}
                                                                        fullWidth
                                                                        sx={{
                                                                            // ...rightTextStyle,
                                                                            "& input::-webkit-calendar-picker-indicator": {
                                                                                display: "none",
                                                                                WebkitAppearance: "none",
                                                                            },
                                                                            "& input[type='date']": {
                                                                                appearance: "none",
                                                                                WebkitAppearance: "none",
                                                                            },
                                                                            "& .MuiOutlinedInput-root": {
                                                                                "& fieldset": {
                                                                                    border: "none",
                                                                                },
                                                                            },
                                                                        }}
                                                                        InputProps={{
                                                                            startAdornment: (
                                                                                <Box sx={{ ml: 2, mr: 1, color: "#433F5E", display: "flex", alignItems: "center", cursor: "pointer" }}

                                                                                >
                                                                                    {calenderSVG}
                                                                                </Box>
                                                                            ),
                                                                            sx: {
                                                                                backgroundColor: "#E7E7EB",
                                                                                height: "40px",
                                                                                width: { xs: "100%", md: "100%" },
                                                                                borderRadius: "3px",
                                                                            },
                                                                        }}
                                                                    />
                                                                </Grid>
                                                                <Grid size={6}>
                                                                    <Typography sx={{
                                                                        fontFamily: 'Outfit',
                                                                        fontWeight: 500,
                                                                        fontSize: '16px',
                                                                        lineHeight: '100%',
                                                                        letterSpacing: "0px",
                                                                        mb: 1
                                                                    }}>Closed Date</Typography>
                                                                    <TextField
                                                                        type="date"
                                                                        name="closed_date"
                                                                        value={filters?.ClosedDate || ""}
                                                                        // onBlur={handleBlur}
                                                                        onChange={(e) => {
                                                                            const selectedDate = e.target.value;

                                                                            setFilters((prev) => ({
                                                                                ...prev,
                                                                                ClosedDate: selectedDate,
                                                                            }));
                                                                        }}
                                                                        onClick={(e) => {
                                                                            // Trigger the native date picker
                                                                            const input = e.currentTarget.parentElement?.querySelector('input[type="date"]');
                                                                            if (input) input.showPicker?.();
                                                                        }}
                                                                        fullWidth
                                                                        sx={{
                                                                            // ...rightTextStyle,
                                                                            "& input::-webkit-calendar-picker-indicator": {
                                                                                display: "none",
                                                                                WebkitAppearance: "none",
                                                                            },
                                                                            "& input[type='date']": {
                                                                                appearance: "none",
                                                                                WebkitAppearance: "none",
                                                                            },
                                                                            "& .MuiOutlinedInput-root": {
                                                                                "& fieldset": {
                                                                                    border: "none",
                                                                                },
                                                                            },
                                                                        }}
                                                                        InputProps={{
                                                                            startAdornment: (
                                                                                <Box sx={{ ml: 2, mr: 1, color: "#433F5E", display: "flex", alignItems: "center", cursor: "pointer" }}

                                                                                >
                                                                                    {calenderSVG}
                                                                                </Box>
                                                                            ),
                                                                            sx: {
                                                                                backgroundColor: "#E7E7EB",
                                                                                height: "40px",
                                                                                width: { xs: "100%", md: "100%" },
                                                                                borderRadius: "3px",
                                                                            },
                                                                        }}
                                                                    />
                                                                </Grid>

                                                                {hasSubProjects && (
                                                                    <Grid size={6}>
                                                                        <Typography sx={{
                                                                            fontFamily: 'Outfit',
                                                                            fontWeight: 500,
                                                                            fontSize: '16px',
                                                                            lineHeight: '100%',
                                                                            letterSpacing: "0px",
                                                                            mb: 1
                                                                        }}>Select Sub Project</Typography>
                                                                        <Select
                                                                            name="SubProject"
                                                                            placeholder="Select Sub Project"
                                                                            value={actionSubProjects.find(opt => opt.value === filters?.SubProject) || null}
                                                                            onChange={(option) => handleSelectChange(option, "SubProject")}
                                                                            options={actionSubProjects}
                                                                        />
                                                                    </Grid>
                                                                )}

                                                                <Grid size={{ sm: 12, md: 6 }}>
                                                                    <FormControlLabel
                                                                        control={
                                                                            <Checkbox
                                                                                checked={filters?.ShowOverdueOnly || false}
                                                                                onChange={(e) => {
                                                                                    setFilters((prev) => ({
                                                                                        ...prev,
                                                                                        ShowOverdueOnly: e.target.checked,
                                                                                    }));
                                                                                }}
                                                                                sx={{
                                                                                    color: "#00344C",
                                                                                    '&.Mui-checked': {
                                                                                        color: "#00344C",
                                                                                    },
                                                                                }}
                                                                            />
                                                                        }
                                                                        label={
                                                                            <Typography
                                                                                sx={{
                                                                                    fontFamily: 'Outfit',
                                                                                    fontWeight: 500,
                                                                                    fontSize: '16px',
                                                                                    lineHeight: '100%',
                                                                                    letterSpacing: "0px",
                                                                                }}
                                                                            >
                                                                                Delayed Task
                                                                            </Typography>
                                                                        }
                                                                    />
                                                                </Grid>
                                                                {/* {
                                                                    isAdmin && tabValue === 6 &&
                                                                    <Grid size={{ sm: 12, md: 6 }}>

                                                                        <FormControlLabel
                                                                            control={
                                                                                <Checkbox
                                                                                    checked={filters.PendingApproval}
                                                                                    onChange={handleCheckboxChange}
                                                                                />
                                                                            }
                                                                            label={
                                                                                <Typography
                                                                                    sx={{
                                                                                        fontFamily: 'Outfit',
                                                                                        fontWeight: 500,
                                                                                        fontSize: '16px',
                                                                                        lineHeight: '100%',
                                                                                        letterSpacing: "0px",
                                                                                    }}
                                                                                >
                                                                                    Is Pending Approval
                                                                                </Typography>
                                                                            }
                                                                        />
                                                                    </Grid>
                                                                } */}

                                                                <Grid size={12}>
                                                                    <Box
                                                                        sx={{
                                                                            display: "flex",
                                                                            justifyContent: "flex-end",
                                                                            alignItems: "center",
                                                                        }}
                                                                    >
                                                                        {isApplyFilter &&
                                                                            <Button onClick={handleReset}
                                                                                sx={{
                                                                                    textTransform: "none",
                                                                                    color: "#F15744",
                                                                                    fontSize: "14px",
                                                                                    lineHeight: "100%",
                                                                                    fontFamily: "Outfit, sans-serif",
                                                                                    borderRadius: "3px",
                                                                                    fontWeight: 500,
                                                                                    px: "20px",
                                                                                    py: "15px",
                                                                                }}>
                                                                                Reset
                                                                            </Button>
                                                                        }

                                                                        <Button
                                                                            type="button"
                                                                            onClick={handleApplyFilters}
                                                                            variant="contained"
                                                                            sx={{
                                                                                backgroundColor: "#00344C",
                                                                                borderRadius: "3px",
                                                                                textTransform: "none",
                                                                                fontWeight: 500,
                                                                                fontSize: "14px",
                                                                                lineHeight: "100%",
                                                                                fontFamily: "Outfit, sans-serif",
                                                                                color: "#FFFFFF",
                                                                                px: "20px",
                                                                                py: "15px",
                                                                            }}
                                                                        >
                                                                            Apply
                                                                        </Button>
                                                                    </Box>
                                                                </Grid>
                                                            </Grid>
                                                        )}
                                                    </Box>


                                                </ClickAwayListener>
                                            </Paper>
                                        </Grow>
                                    )}
                                </Popper>
                                <IconButton onClick={handleExportExcel} disabled={isExporting}>
                                    <MdOutlineFileDownload size={24} color="#48535B" />
                                </IconButton>
                                <IconButton onClick={handleRefresh} disabled={isFetching}>
                                    <LuRefreshCw size={20} color="#48535B" style={{
                                        animation: isFetching ? "spin 1s linear infinite" : undefined,
                                    }} />
                                    <style jsx>{`
                                        @keyframes spin {
                                        to {
                                            transform: rotate(360deg);
                                        }
                                        }
                                    `}</style>
                                </IconButton>
                            </Box>
                        </Grid>
                        <Grid size={12}>
                            <Box sx={{ display: "flex", gap: 1, flexWrap: "wrap", mt: 1 }}>
                                <Chip
                                    label="Completed/Closed"
                                    sx={{
                                        color: "#34A853",
                                        backgroundColor: "#E1FFBB",
                                        fontWeight: 500,
                                        height: "20px",
                                        borderRadius: "3px",
                                        //padding: "2px 6px",
                                        fontFamily: "Inter, Outfit, sans-serif",
                                        fontSize: "12px",
                                        marginRight: "5px",
                                    }}
                                />
                                <Chip
                                    label="Ontime"
                                    sx={{
                                        color: "white",
                                        backgroundColor: "orange",
                                        fontWeight: 500,
                                        height: "20px",
                                        borderRadius: "3px",
                                        //padding: "2px 6px",
                                        fontFamily: "Inter, Outfit, sans-serif",
                                        fontSize: "12px",
                                        marginRight: "5px",
                                    }}
                                />
                                <Chip
                                    label="Delayed"
                                    sx={{
                                        color: "#e51c1cff",
                                        backgroundColor: "#f5ccccff",
                                        fontWeight: 500,
                                        height: "20px",
                                        borderRadius: "3px",
                                        //padding: "2px 6px",
                                        fontFamily: "Inter, Outfit, sans-serif",
                                        fontSize: "12px",
                                        marginRight: "5px",
                                    }}
                                />
                            </Box>
                        </Grid>
                    </Grid>
                </Grid>
                <Grid size={12}>
                    <Box sx={{ backgroundColor: "#FFFFFF", border: `1px solid ${enterpriseTokens.lineSoft}`, borderTop: 0, borderRadius: "0 0 3px 3px", overflow: "hidden", boxShadow: "0 2px 8px rgba(15, 23, 42, 0.05)" }}>
                    {/* {
                        tabValue === 0 &&
                        <> */}
                    <TableComponent
                        columns={columns}
                        data={actionTrackerList?.data}
                        createSortHandler={handleRequestSort}
                        isLoading={isFetching}
                        order={sortOrder}
                        orderBy={sortBy}
                    />
                    <Menu
                        anchorEl={menuAnchorEl}
                        open={Boolean(menuAnchorEl)}
                        onClose={handleMenuClose}
                        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
                        transformOrigin={{ vertical: "top", horizontal: "right" }}
                        PaperProps={{
                            elevation: 0,
                            sx: {
                                mt: 1,
                                borderRadius: "3px",
                                minWidth: 140,
                                border: "1px solid #E5E9EB",
                                boxShadow: "0px 10px 30px rgba(15, 23, 42, 0.12)",
                                overflow: "hidden",
                            },
                        }}
                        MenuListProps={{
                            sx: {
                                py: 0.5,
                            },
                        }}
                    >
                        {viewAccess && <MenuItem
                            onClick={handleMenuView}
                            sx={{
                                fontFamily: "Outfit, sans-serif",
                                fontSize: "14px",
                                fontWeight: 400,
                                px: 1.5,
                                py: 1,
                                display: "flex",
                                alignItems: "center",
                                gap: 1,
                                color: "#111827",
                                "&:hover": {
                                    backgroundColor: "#F6F8F9",
                                },
                            }}
                        >
                            <LuEye size={16} style={{ color: "#4B5563" }} />
                            <span>View</span>
                        </MenuItem>
                        }

                        {editAccess &&
                            <MenuItem
                                onClick={handleMenuEdit}
                                sx={{
                                    fontFamily: "Outfit, sans-serif",
                                    fontSize: "14px",
                                    fontWeight: 400,
                                    px: 1.5,
                                    py: 1,
                                    display: "flex",
                                    alignItems: "center",
                                    gap: 1,
                                    color: "#111827",
                                    "&:hover": {
                                        backgroundColor: "#F6F8F9",
                                    },
                                }}
                            >
                                <EditIcon style={{ width: 14, height: 14 }} />
                                <span>Edit</span>
                            </MenuItem>
                        }
                        {deleteAccess && <MenuItem
                            onClick={handleDeleteActionTracker}
                            sx={{
                                fontFamily: "Outfit, sans-serif",
                                fontSize: "14px",
                                fontWeight: 400,
                                px: 1.5,
                                py: 1,
                                display: "flex",
                                alignItems: "center",
                                gap: 1,
                                color: "#111827",
                                "&:hover": {
                                    backgroundColor: "#F6F8F9",
                                },
                            }}
                        >
                            <MdDeleteOutline style={{ width: 14, height: 14 }} />
                            <span>Delete</span>
                        </MenuItem>}

                    </Menu>
                    {/* <TablePagination
                        rowsPerPageOptions={[5, 10, 25]}
                        component="div"
                        count={0}
                        rowsPerPage={5}
                        page={0}
                    // onPageChange={handleChangePage}
                    // onRowsPerPageChange={handleChangeRowsPerPage}
                    /> */}
                    <CustomPagination
                        totalCount={actionTrackerList?.totalRecords || 0}
                        pageSize={pageSize}
                        page={pageNumber}
                        onPageChange={handlePageChange}
                        setCurrentPage={setPageNumber}
                        onPageSizeChange={handlePageSizeChange}
                    />
                    </Box>
                    {/* </>
                    } */}
                    {/* {
                        tabValue === 1 && <TableComponent columns={columns} data={actionTrackerList?.data?.data?.filter(item => item.status === "Pending")} loading={loading} />
                    }
                    {
                        tabValue === 2 && <TableComponent columns={columns} data={actionTrackerList?.data?.data?.filter(item => item.status === "In Progress")} loading={loading} />
                    }
                    {
                        tabValue === 3 && <TableComponent columns={columns} data={actionTrackerList?.data?.data?.filter(item => item.status === "Closed")} loading={loading} />
                    } */}
                    {/* <TableComponent columns={columns} data={tableData} loading={loading} /> */}
                </Grid>


            </Grid >
            </EnterprisePageShell>


            {isAddActionTracker &&
                <AddActionTracker open={isAddActionTracker} handleClose={handleAddActionTracker} actionContact={actionContact} />
            }

            {
                isEditTracker &&
                <EditActionTracker open={isEditTracker} handleClose={handleEditTracker} rowData={rowData} actionContact={actionContact} mainTabValue={tabValue} tabLength={filteredtabs.length - 1} />
            }

            {
                isViewTracker &&
                <ViewActionTracker open={isViewTracker} handleClose={handleViewClick} rowData={rowData} />
            }

        </>
    );
}

export default ActionTracker;
